var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllStudentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#40499D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.5C20.9283 13.5 21.8185 13.8687 22.4749 14.5251C23.1313 15.1815 23.5 16.0717 23.5 17C23.5 17.9283 23.1313 18.8185 22.4749 19.4749C21.8185 20.1313 20.9283 20.5 20 20.5C19.0717 20.5 18.1815 20.1313 17.5251 19.4749C16.8687 18.8185 16.5 17.9283 16.5 17C16.5 16.0717 16.8687 15.1815 17.5251 14.5251C18.1815 13.8687 19.0717 13.5 20 13.5ZM13 16C13.56 16 14.08 16.15 14.53 16.42C14.38 17.85 14.8 19.27 15.66 20.38C15.16 21.34 14.16 22 13 22C12.2044 22 11.4413 21.6839 10.8787 21.1213C10.3161 20.5587 10 19.7956 10 19C10 18.2044 10.3161 17.4413 10.8787 16.8787C11.4413 16.3161 12.2044 16 13 16ZM27 16C27.7956 16 28.5587 16.3161 29.1213 16.8787C29.6839 17.4413 30 18.2044 30 19C30 19.7956 29.6839 20.5587 29.1213 21.1213C28.5587 21.6839 27.7956 22 27 22C25.84 22 24.84 21.34 24.34 20.38C25.2119 19.2544 25.6166 17.8362 25.47 16.42C25.92 16.15 26.44 16 27 16ZM13.5 26.25C13.5 24.18 16.41 22.5 20 22.5C23.59 22.5 26.5 24.18 26.5 26.25V28H13.5V26.25ZM8 28V26.5C8 25.11 9.89 23.94 12.45 23.6C11.86 24.28 11.5 25.22 11.5 26.25V28H8ZM32 28H28.5V26.25C28.5 25.22 28.14 24.28 27.55 23.6C30.11 23.94 32 25.11 32 26.5V28Z",
    fill: "#40499D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStudentsIcon);
export default __webpack_public_path__ + "static/media/AllStudentsIcon.4c130219243952edc3356dcdc7452566.svg";
export { ForwardRef as ReactComponent };